import { Dialog, DialogStore } from "@ariakit/react";
import { ReactNode } from "react";
import * as css from "./style.css";

export function ModalDialog(props: {
  store?: DialogStore;
  children: ReactNode;
  variant?: "form" | "confirm";
}) {
  return (
    <Dialog
      modal
      store={props.store}
      className={css.dialog({ variant: props.variant })}
      backdrop={<div className={css.backdrop} />}
    >
      {props.children}
    </Dialog>
  );
}
